export enum EUploadAttachmentStatus {
  GettingUploadLink = 10,
  UploadingAttachment = 50,
  Finalizing = 90,
  Completed = 100,
}
